import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import { Icon } from '@sdb/planning-ui';

export default function ShowWarning() {
  const { t } = useTranslation('common');

  return (
    <Tooltip title={t('noActionSelected') || ''} arrow disableInteractive>
      <Icon
        type="triangle-exclamation"
        fontSize="small"
        color="warning"
        className="warning-icon"
      />
    </Tooltip>
  );
}
